<template>
  <footer>
    <div class="footer">
      <div class="main">
        <div class="footer_top">
          <img :src="`${$baseUrl}images/ewm.jpg`" alt="扫码关注">
          <ul>
            <li><a href="#">首页</a></li>
            <li><a href="#">绘画</a></li>
            <li><a href="#">书法</a></li>
            <li><a href="#">资讯</a></li>
            <li><a href="#">关于</a></li>
          </ul>
        </div>
        <div class="footer_bottom">
          <p>名称：{{ configData.name }}</p>
          <p>邮箱：{{ configData.contact }}</p>
          <a href="https://beian.miit.gov.cn/#/Integrated/index">备案号：{{ configData.beian }}</a>
          <p @click="showDisclaimer">免责声明</p>
          <p>京公网安备11010802039272号</p>
        </div>
      </div>
    </div>
    
    <!-- 免责声明弹窗 -->
    <div class="f" v-show="disclaimerVisible">
      <div class="f_top">
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAR5JREFUWEfVl9sOwyAMQ5cvX/vlnUBF6iUX20XT1pepoosPJgFir8OzbdvSXs2s/85+vPg2RPbB9/6+zoaI4neAy+BgmgaRxbdgcBpEGb/4oIHITkCxkyU45iANAYmbLVESegUAQ6DiveKcMhyVIEEw4jeAp8vBirsAKoQiHgKwEKp4CoBC7Iki580pCb2sA2aXHRll5ZQAoBNSxZRLQJaotHFBDgQnZmR9afvxj/8DQCYj7ALkAClOHeUlgCgOQ6QAgHi7O7YY8zciRNzMVnCfCHPCdYARJ0rUhbgBKOJPINgLyTJsj3YhYAInJ5grWSmuOJH1BdLezkJUfUGLB+9q12WBlqNsHB72iWX8pI7lmYNO9Pi/0ZxeEuer7fkH7+AKJCy8PQwAAAAASUVORK5CYII=" alt="关闭" @click="hideDisclaimer">
      </div>
      <div class="html">
        <!-- 加载状态 -->
        <div v-if="disclaimerLoading" class="loading">
          <div class="loading-spinner"></div>
          <p>加载中...</p>
        </div>
        
        <!-- 动态内容 -->
        <div v-else-if="disclaimerContent" v-html="disclaimerContent" class="disclaimer-content"></div>
        
        <!-- 默认内容（备用） -->
        <div v-else class="disclaimer-content">
          <div class="tit">免责声明</div>
          <p>任何用户在使用之前，均应仔细阅读本声明，否则，即被视为对本声明全部内容的认可和接受。</p>
          <p>1、我公司尊重并保护所有使用用户的个人隐私权，您注册的用户名、电子邮件地址等个人资料，非经您亲自许可或根据相关法律、法规的强制性规定，我们不会泄露给第三方。</p>
          <p>2、我们采用的非本站原创图片音视频等内容的版权事宜，作如下声明：</p>
          <p>（1）所有的文章、图片文件等等资料的版权归版权所有人所有。</p>
          <p>（2）如果您是文章、图片等资料的版权所有人，请与我们联系并说明具体文章标题，我们会及时加上版权信息，如果您反对我们的使用，本着对版权人尊重的原则，我们会立即移除有版权问题的内容。</p>
          <p>（3）免责：我们在我们能知悉的范围内努力保证所有内容的真实性和正确性，但不对真实性和正确性做任何保证，本站内容如果和事实有所出入，本站不承担连带责任。</p>
          <p>3、发生下列情况时，本网站亦毋需承担任何责任：</p>
          <p>（1）由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露。</p>
          <p>（2）任何由于计算机系统问题、黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被篡改等。</p>
          <p>对免责声明的解释、修改及更新权均属于本网站所有。</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { apiService } from '@/api'

export default {
  name: 'Footer',
  props: {
    configData: {
      type: Object,
      default: () => ({
        name: '温故科技',
        contact: 'wengukeji@163.com',
        beian: '京ICP备2022006303号'
      })
    }
  },
  data() {
    return {
      disclaimerVisible: false,
      disclaimerContent: '',
      disclaimerLoading: false
    }
  },
  methods: {
    async showDisclaimer() {
      this.disclaimerVisible = true
      
      // 如果已经有内容，不重复请求
      if (this.disclaimerContent) {
        return
      }
      
      try {
        this.disclaimerLoading = true
        const response = await apiService.getConfig('contents')
        
        if (response && response.data) {
          // API返回的是HTML字符串，需要解码
          this.disclaimerContent = response.data
        } else {
          // 如果接口失败，使用默认内容
          this.disclaimerContent = this.getDefaultDisclaimer()
        }
      } catch (error) {
        console.error('获取免责声明失败:', error)
        // 使用默认内容
        this.disclaimerContent = this.getDefaultDisclaimer()
      } finally {
        this.disclaimerLoading = false
      }
    },
    
    hideDisclaimer() {
      this.disclaimerVisible = false
    },
    
    getDefaultDisclaimer() {
      return `
        <div class="tit">免责声明</div>
      `
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: #FFFFFF;
  border-top: 1px solid #f0f0f0;
  padding: 40px 0;
  
  .main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .footer_top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;
    
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }
    
    img {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 8px;
    }
    
    ul {
      display: flex;
      gap: 30px;
      list-style: none;
      margin: 0;
      padding: 0;
      
      @media (max-width: 768px) {
        gap: 20px;
        flex-wrap: wrap;
        justify-content: center;
      }
      
      li {
        a {
          color: #666;
          font-size: 14px;
          text-decoration: none;
          transition: color 0.3s ease;
          cursor: pointer;
          
          &:hover {
            color: var(--primary-color, #8B4513);
          }
        }
      }
    }
  }
  
  .footer_bottom {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #333;
    padding-top: 20px;
    border-top: 1px solid #333;
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
      text-align: center;
    }
    
    p, a {
      margin: 0;
      color: #333;
      text-decoration: none;
      transition: color 0.3s ease;
      font-size: 14px;
      white-space: nowrap;
      
      @media (max-width: 768px) {
        white-space: normal;
      }
      
      &:hover {
        color: var(--primary-color, #8B4513);
      }
    }
    
    p {
      cursor: pointer;
      
      &:hover {
        color: var(--primary-color, #8B4513);
      }
    }
    
    a {
      transition: color 0.3s ease;
      
      &:hover {
        color: var(--primary-color, #8B4513);
      }
    }
  }
}

// 免责声明弹窗样式
.f {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  
  .f_top {
    position: absolute;
    top: 20px;
    right: 20px;
    
    img {
      width: 32px;
      height: 32px;
      cursor: pointer;
      opacity: 0.8;
      transition: opacity 0.3s ease;
      
      &:hover {
        opacity: 1;
      }
    }
  }
  
  .html {
    background: white;
    border-radius: 8px;
    max-width: 800px;
    max-height: 80vh;
    overflow-y: auto;
    padding: 40px;
    
    @media (max-width: 768px) {
      padding: 20px;
      margin: 0 10px;
    }
    
    // 加载状态样式
    .loading {
      text-align: center;
      padding: 60px 20px;
      
      .loading-spinner {
        width: 40px;
        height: 40px;
        border: 3px solid #f3f3f3;
        border-top: 3px solid #8B4513;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 20px;
      }
      
      p {
        color: #666;
        font-size: 14px;
        margin: 0;
      }
      
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    }
    
    // 免责声明内容样式
    .disclaimer-content {
      .tit {
        padding: 20px 0;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
        color: #2c3e50;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        margin-bottom: 20px;
        border-bottom: 1px solid #eee;
      }
      
      p {
        padding: 0;
        margin-bottom: 16px;
        line-height: 2;
        color: #2c3e50;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        font-size: 14px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
